import { getApiOrigin } from '@hungryroot/rest';
import { type SignupResponse } from '@hungryroot/rest/api/signup/post';
import { onSignupSuccess } from '../on-signup-success';
import { waitAndReload } from '../redirects';

interface Params {
  $wrapper: JQuery<HTMLElement>;
  $login: JQuery<HTMLElement>;
  $errorContainer: JQuery<HTMLElement>;
  redirectUrl?: string;
  initializeNow?: true;
}

interface GoogleSignInData {
  idToken: string;
}

interface GoogleLoginResponse {
  credential: string;
}

interface LoginData {
  created: boolean;
  customer: SignupResponse;
}

const googleSignIn = (data: GoogleSignInData) => {
  return new Promise((resolve, reject) => {
    let options = {
      type: 'POST',
      url: `${getApiOrigin()}/api/google_login`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `Got ${textStatus} when trying to signup Google User. Error: ${errorThrown}`
      );
    });
  });
};

const createFakeGoogleWrapper = () => {
  const googleLoginWrapper = document.createElement('div');
  googleLoginWrapper.style.display = 'none';
  googleLoginWrapper.classList.add('custom-google-button');

  document.body.appendChild(googleLoginWrapper);

  // Render the button inside our wrapper; button will not show
  window.google.accounts.id.renderButton(googleLoginWrapper, {
    type: 'icon',
    width: '200',
  });

  const googleLoginWrapperButton: HTMLElement | null =
    googleLoginWrapper.querySelector('div[role=button]');

  return {
    click: () => {
      googleLoginWrapperButton?.click();
    },
  };
};

export function init(params: Params) {
  const { $wrapper, $login, $errorContainer, redirectUrl, initializeNow } =
    params;
  let googleButtonWrapper: { click: () => void };
  let googleExpectedEvent: string;
  let event_type: string;

  function initializeGoogle() {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: `${window.gClientId}`,
        ux_mode: 'popup',
        callback: (response: GoogleLoginResponse) => {
          googleSignIn({ idToken: response.credential })
            .then((data) => {
              const { customer, created } = data as LoginData;
              if (!data || !('created' in (data as LoginData))) {
                event_type = googleExpectedEvent;
              } else {
                if (created === true) {
                  event_type = 'signup';
                } else {
                  event_type = 'login';
                }
              }

              if (typeof ga === 'function') {
                ga('send', 'event', event_type, 'success');
              }

              const customerData = {
                id: customer.id,
                email: customer.email,
              };
              if (event_type === 'signup') {
                if (typeof dataLayer.push === 'function') {
                  dataLayer.push({
                    event: 'hr.signup.success',
                    signup: {
                      method: 'google',
                    },
                    customer: customerData,
                  });
                }
                onSignupSuccess(customer.id, redirectUrl, customer, 'google');
              } else if (event_type === 'login') {
                if (typeof dataLayer.push === 'function') {
                  dataLayer.push({
                    event: 'hr.login.success',
                    login: {
                      method: 'google',
                    },
                    customer: customerData,
                  });
                }
                waitAndReload();
              }
            })
            .catch(() => {
              $errorContainer.show();
              $login
                .find('.dialog')
                .effect('shake', { times: 3, displace: 10 });
            });
        },
      });
      googleButtonWrapper = createFakeGoogleWrapper();
    }
  }

  /*

    Super fun hack
    Sometimes we want this function to run on window load
    but on other pages (/signup/), window.load is already called
    by the time we get here so we want to opt out of that
  */
  if (initializeNow === true) {
    initializeGoogle();
  } else {
    window.onload = initializeGoogle;
  }

  $wrapper.on('click', function () {
    googleExpectedEvent =
      $(this).attr('class') == 'google-login-button' ? 'login' : 'signup';

    googleButtonWrapper?.click();
  });
}
